module.exports = __webpack_public_path__ + "img/antes_despues_197.1d63458c.png";